import { render, staticRenderFns } from "./CliffDwellings.vue?vue&type=template&id=0c77d47e&scoped=true&lang=html&"
import script from "./CliffDwellings.vue?vue&type=script&lang=js&"
export * from "./CliffDwellings.vue?vue&type=script&lang=js&"
import style0 from "./CliffDwellings.vue?vue&type=style&index=0&id=0c77d47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c77d47e",
  null
  
)

export default component.exports